import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitQuote = (payload) => api.post("/quotes", payload).then((r) => r.data);

export const createCheckout = (items, origin_url) =>
  api.post("/checkout/session", { items, origin_url }).then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);
